import * as React from 'react';

import { connect } from 'react-redux';

import { Dispatch } from 'redux';

import { Form, FormValues, FormApi } from 'informed';

import { Button } from 'reactstrap';

import { assign as _assign } from 'lodash';

import { 
  ConfigurationModel, 
  ProjectModel,
  UserDataModel,
  UserModel, 
} from 'franke-trough-dependencies';

import {
  NewProjectFormModel,
  newProjectFormValues,
  InputValue,
  renderFields,
  GlobalPrivateState,
  FormDefaultState,
  formDefaultState,
} from 'src/api';

import { requestAPIActions, RequestApiResult, RequestApiHttpPayload, RequestApiError} from 'loopback-react-request';

import './ProjectNewForm.scss';
import { RouterState } from 'connected-react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectNewForm.messages';
import { userIsInternal, userIsSalesRep, userIsExternal } from '../../Admin/utils';

interface ProjectNewFormProps {
  configuration: RequestApiResult<ConfigurationModel>;
  dispatch: Dispatch;
  forConfiguration?: boolean;
  location: RouterState['location'];
  project: RequestApiResult<ProjectModel>;
  user: RequestApiResult<UserModel>;
  userData: RequestApiResult<UserDataModel>;
  submitted?: (success: boolean) => void;
}

interface ProjectNewFormState extends FormDefaultState<NewProjectFormModel> {
  loading: boolean;
  requestError?: RequestApiError;
  requestSuccess: boolean;
  submitValues: {[key: string]: InputValue};
  submitted: boolean;
}

/**
 * FIXME: use FormHoc
 */

class ProjectNewFormComponent extends React.Component<ProjectNewFormProps, ProjectNewFormState> {
  constructor(props: ProjectNewFormProps) {
    super(props);

    const isInternalUser = this.props.user && userIsInternal(this.props.user.result);

    this.state = {
      formFields: newProjectFormValues(isInternalUser),
      formHasErrors: true,
      formState: formDefaultState,
      loading: false,
      requestSuccess: false,
      submitValues: {},
      submitted: false,
    };

    this.getFormApi = this.getFormApi.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePreSubmit = this.handlePreSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate(prevProps: ProjectNewFormProps) {    
    const {configuration, project, userData, user} = this.props;
    const {loading, formFields, formApi} = this.state;
    
    if (user.result && user.loaded && !user.updating && JSON.stringify(prevProps.user.result) !== JSON.stringify(user.result)) {
      const isInternalUser = this.props.user && userIsInternal(user.result);
      
      this.setState({
        formFields: newProjectFormValues(isInternalUser)
      });
    }
    if (project.updating && !loading) {
      this.setState({loading: true});
    }
    if (project.result && loading && !project.updating) {
      this.setState({loading: false});
      if (project.result && !project.updating && project.loaded) {
        this.setState({requestSuccess: true});
        if (this.props.submitted) {
          this.props.submitted(true);
        }
        if (this.props.forConfiguration) {
          this.props.dispatch(requestAPIActions.load(
            'configuration', {
              url: `/Configurations/${configuration.result && configuration.result.id}`,
              options: {
                method: 'PATCH',
                data: {
                  projectId: project.result.id
                }
              },
            },
            true
          ));
          this.props.dispatch(requestAPIActions.load(
            'projects', {
              url: `/UserData/${userData.result && userData.result.id}/Projects`
            },
            true
          ));
        }
      }
    }
    if (project.error && loading) {      
      if (formApi && formFields) {
        const values = {};
        Object.keys(formFields).map(key => _assign(values, {[key]: formFields[key].value}));
        formApi.setValues(values);
      }
      this.setState({
        requestError: project.error,
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared('project'));
  }

  render() {
    const { user } = this.props;
    const { formFields, formHasErrors, requestError, formState } = this.state; 
    return (
      <div className="partial-project-form my-0 mx-auto mb-5">
        <Form
          getApi={this.getFormApi}
          initialValues={formState.values}
          onSubmit={this.handleSubmit} 
          onValueChange={this.handleChange}
        >
           {({formState}) => (
             <>   
              <div className="row m-0">
                <div className="col-12">
                  {requestError && (
                    <p className="text-danger">
                      {requestError.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="row m-0">
                {formFields && Object.keys(formFields).map((fieldKey: string, index: number) => {
                  const key = `form_field_${fieldKey}_${index}`;
                  const field = formFields[fieldKey];
                  field.disabled = this.props.project.updating;

                  return (
                    <div key={key} className={field.col ? `col-12 col-sm-${field.col}` : 'col-12'}>
                      {renderFields<NewProjectFormModel>({
                        field: field,
                        formState: formState,
                        index: fieldKey,
                      })}
                    </div>
                  );
                })}
              </div>
              <div className="row m-0">
                <div className="col-12 text-center">
                  <Button
                    className="register-button mt-3" 
                    type="submit"
                    disabled={formHasErrors}
                  >
                    <FormattedMessage {...MESSAGES.projectNewFormButton} />
                  </Button>
                  {/* <a
                    className="w-100 d-block mt-3 without-object"
                    onClick={this.handleSubmit}
                  >
                    I´d like to proceed without an object
                  </a> */}
                </div>
              </div>
            </>
           )}
        </Form>
      </div>
    );
  }

  private getFormApi(formApi: FormApi<FormValues>) {
    this.setState({formApi});
  }

  private handleChange(value: FormValues) {
    if (!this.state.formApi) {
      return;
    }
    
    const formState = this.state.formApi.getState();
    const {errors} = formState;
    const errorKeys = errors && Object.keys(errors);
    const formHasErrors = errorKeys && errorKeys.length > 0 ? true : false;
   
    this.setState({
      formState,
      formHasErrors,
      formErrors: !formState.pristine ? formState.errors : {},
    });
  }

  private handlePreSubmit(values: FormValues): FormValues {
    const {
      user,
      userData,
    } = this.props;

    const { 
      formState, 
      formFields,
      // submitValues, 
    } = this.state;

    // _assign(submitValues, values);

    if (user && user.result) {
      values.userId = user.result.id;
    }

    if (userData && userData.result) {
      values.userdataId = userData.result.id;
    }

    if (formFields) {
      Object.keys(formFields).map(key => formFields[key].value = values[key]);
    }

    this.setState({
      formState,
      // submitValues,
    });

    return values;
  }

  private handleSubmit(values: FormValues): void {
    const {formHasErrors} = this.state;
    if (!formHasErrors) {
      this.dispatchRegister(values);
    }
  }

  private dispatchRegister(values: FormValues) {
    const { userData } = this.props;
    const { submitValues, formApi } = this.state;
    if (userData && userData.result) {

      if (formApi) {
        const valuesToSet = submitValues as FormValues;
        formApi.setValues(valuesToSet);
      }

      const valuesToDispatch = this.handlePreSubmit(values);

      this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
        'project', {
          url: `/UserData/${userData.result.id}/Projects`,
          options: {
            method: 'POST',
            data: valuesToDispatch,
          },
        },
        true
      ));
  
      this.setState({
        submitted: true,
        formHasErrors: false,
      });
    }
  }

}

export const ProjectNewForm = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  location: state.router.location,
  project: state.project,
  userData: state.userData,
  user: state.user,
}))(ProjectNewFormComponent);




/*
  FIXME: Bottom code is to used with HOC. It will we be active once HOC is finalised.
*/



// import * as React from 'react';

// import { connect } from 'react-redux';

// import { assign as _assign } from 'lodash';

// import {
//   CreateFormProps,
//   GlobalState,
//   formatMessage
// }
//   from 'src/api';

// import {
//   NewProjectFormModel,

//   // GlobalPrivateState,
//   // FormDefaultState,
//   // formDefaultState,
// } from 'src/api';


// import {
//   createForm, 
//   FormValues, 
//   FormWrappedComponentProps
// } from 'src/api/models/Form/Form';

// import {
//   newProjectFormValues,
// } from 'src/api/models/Project/new/new-project.class';

// import { requestAPIActions,RequestApiHttpPayload} from 'loopback-react-request';

// import './ProjectNewForm.scss';

// import MESSAGES from './ProjectNewForm.messages';


// // interface ProjectNewFormProps {
// //   submitted?: (success: boolean) => void;
// //   forConfiguration?: boolean;
// // }



// export const NewProjectFormResult = (props: FormWrappedComponentProps<NewProjectFormModel>) => {

//   const {
//     requestError,
//     values,
//   } = props;

// return requestError ? (
//   <div className="row m-0 alert-failed">
//            {requestError.message} {requestError.code === 'EMAIL_NOT_VALID' && values && (
//               <ProjectNewForm/>
//           )}
//   </div>
//   ) : null;
// }

// const NewProjectFormModelFormProperty = createForm<NewProjectFormModel, CreateFormProps<NewProjectFormModel>>({
//   className: 'partial-login-form my-0 mx-auto',
//   dispatchData: (dispatch, values, state) => {
//     let userData = state && state.userData && state.userData.result;

//     dispatch(requestAPIActions.load<RequestApiHttpPayload>(
//       'project', {
//         url: `/UserData/${userData && userData.id}/Projects`,
//         options: {
//           method: 'POST',
//           data: values,
//         },
//       },
//       true
//     )
//   )},

//   formFields: newProjectFormValues(),
//   preSubmit: (values: FormValues<NewProjectFormModel>, state: GlobalState | undefined) => {
//     let userData = state && state.userData && state.userData.result;

//     if (userData && userData.id) {
//       _assign(values, {userId : userData.id, userdataId : userData.id});
//     }


//     return values
//   },
//   redirectTo: '/',
//   shouldRedirect: false,
//   stateKeys: 'project',
//   submitButton: {
//     text: formatMessage({...MESSAGES.projectNewFormButton}),
//     className: 'register-button mt-3'
//   }
// })(NewProjectFormResult);


// export const ProjectNewForm = connect((state: GlobalState) => ({state}))(NewProjectFormModelFormProperty);



